import Vue from 'vue'
import VueRouter from 'vue-router'
import { getUrlParam } from '@/utils/utils'
import store from '@/store'
Vue.use(VueRouter)

import UnpaidBills from '@/pages/tabbar/UnpaidBills.vue'
import PaidBills from '@/pages/tabbar/PaidBills.vue'
import DeliveryList from '@/pages/tabbar/DeliveryList.vue'
import User from '@/pages/tabbar/User.vue'
import Login from '@/pages/Login'
import BillDetail from '@/pages/normal/BillDetail/Index.vue'

// 防止重复路由报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/login',
    component: Login
  },
  {
    path: '/',
    component: UnpaidBills,
    meta: {
      title: '待支付账单',
      needLogin: true,
      keepAlive: true
    }
  },
  {
    path: '/paid',
    component: PaidBills,
    meta: { 
      title: '已支付账单', 
      needLogin: true,
      keepAlive: true
    }
  },
  {
    path: '/user',
    component: User,
    meta: { 
      title: '我的信息', 
      needLogin: true,
      keepAlive: true
    }
  },
  {
    path: '/delivery',
    component: DeliveryList,
    meta: { 
      title: '送货列表', 
      needLogin: true,
      keepAlive: true,
      employee: true // 标记为员工专用页面
    }
  },
  {
    path: '/billDetail/:id',
    name: 'billDetail',
    component: BillDetail,
    meta: {
      title: '账单详情',
      needLogin: true
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果存在保存的位置，则恢复到该位置
      return savedPosition
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 }
    }
  }
})

// 当前正在进行的路由动作
let pendingNavigation = null
// 前一个路由
let previousNavigation = null

router.beforeEach(async (to, from, next) => {
  // 如果有正在进行的导航且前后两个导航的目标路径相同，则中断当前导航
  // 但允许 tabbar 页面之间的切换
  const tabbarPaths = ['/', '/paid', '/user']
  const isTabbarNavigation = tabbarPaths.includes(to.path) && tabbarPaths.includes(from.path)
  
  if (pendingNavigation && pendingNavigation.path === to.path && !isTabbarNavigation) {
    next(false)
    return
  }
  
  // 记录当前导航
  previousNavigation = pendingNavigation
  pendingNavigation = to
  
  // 检查URL中是否包含code参数
  const code = getUrlParam(window.location.href, 'code')
  
  // 如果URL中包含code参数且不是登录页面，直接执行登录流程
  if (code && to.path !== '/login') {
    try {
      // 保存当前要访问的页面路径
      localStorage.setItem('user_path', to.fullPath)
      
      // 调用登录方法
      await store.dispatch('login/login', code)
      console.log('自动登录成功')
      
      // 继续导航
      next()
      return
    } catch (error) {
      console.error('自动登录失败:', error)
      // 登录失败时继续检查是否需要登录
    }
  }
  
  const { needLogin } = to.meta
  const token = localStorage.getItem('user_tokenValue')
  
  // 判断是否是登录页面
  if (to.path === '/login') {
    next()
    return
  }
  
  // 需要登录且没有token的情况
  if (needLogin && !token) {
    // 保存当前要访问的页面路径，登录后重定向回来
    localStorage.setItem('user_path', to.fullPath)
    Vue.prototype.$checkLogin()
    next(false) // 中断当前导航
    return
  }
  
  // 检查员工权限
  if (to.meta.employee) {
    try {
      const { getUserInfo } = require('@/api/user')
      const res = await getUserInfo()
      if (res.code === 200 && res.user && res.user.employee !== true) {
        // 非员工访问员工页面，重定向到首页
        next('/')
        return
      }
    } catch (error) {
      console.error('权限验证失败', error)
    }
  }
  
  next()
})

router.afterEach(to => {
  // 完成导航后，清除当前导航记录
  if (pendingNavigation && pendingNavigation.path === to.path) {
    pendingNavigation = null
  }
  
  window.entryUrl = `${window.location.origin}${window.location.pathname}#${to.path}`
  console.log('window.entryUrl:', window.entryUrl)
  const { title } = to.meta
  if (title) {
    document.title = to.meta.title
  }
})

export default router
